import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { cn } from "tailwind-variants";

import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { useShowEditToolsAiImageRefinement } from "@design-lab/shared/lib/config";
import { TabNavigation, type TabNavigationItem } from "@design-lab/shared/ui";

import { aiRefineGeneratingAtom } from "@design-lab/entities/artwork";

type RefineToolTabsProps = {
  activeTool: string;
  onToolChange: (tool: string) => void;
};

export function RefineToolTabs({ activeTool, onToolChange }: RefineToolTabsProps) {
  const isGenerating = useAtomValue(aiRefineGeneratingAtom);
  const { isDesktop } = useResponsive();
  const showAiRefine = useShowEditToolsAiImageRefinement();

  const tabs = useMemo(() => {
    const items: TabNavigationItem[] = [
      { id: "erase", label: "Erase", testId: "refine-tab-erase" },
      { id: "negative", label: "Remove Color", testId: "refine-tab-negative" }
    ];

    if (showAiRefine) {
      items.push({ id: "refine", label: "Edit Artwork", testId: "refine-tab-ai" });
    }

    return items;
  }, [showAiRefine]);

  return (
    <div
      className={cn(
        "z-10 w-full max-w-3xl",
        isDesktop && "absolute left-1/2 top-2 w-[92%] -translate-x-1/2"
      )}
    >
      <TabNavigation
        tabs={tabs}
        activeTab={activeTool}
        onTabChange={onToolChange}
        className={cn(isGenerating && "pointer-events-none opacity-50")!}
      />
    </div>
  );
}
